export default __webpack_public_path__ + "media/images/tache-e8572db3ef831e8986afc34b8443d35a.png";